import * as React from 'react';
import { Flex, Box } from 'reflexbox';
import { Translate, TranslateSwitch } from "../tr";
import BuyForm from "../../features/BuyForm/BuyForm";
import Img from "gatsby-image";
import {LI, UL} from "../typography/styled/typography";
import { ModalData } from './Modal';
import { Image } from './styled/modal';

interface ImageDetailContentProps {
  data: ModalData,
  imgTitle: string;
  photo?: {
    original: {
      src: string;
      height: string;
      width: string;
    }
    alt: string;
  }
}

export const ImageDetailContent = ({ data, imgTitle }: ImageDetailContentProps) => {
  return (
    <Flex flexWrap={'wrap'}>
      <Box width={[1, 1, 1, 3/5, 3/5]} px={[0, 3, 3, 0, 0]} pr={[0,0,0,5,5]} pb={[5]}>
        <Box>
          <h3><Translate text={'I\'m interested about this artwork'} /></h3>
          <TranslateSwitch
            en={(
              <p>
                Do you like this piece of art? You can have your own copy or original itself!<br/> Let me know through the form what you are interested in.
              </p>
            )}
            cs={(
              <p>
                Líbí se ti tenhle kousek? Můžeš mít kopii nebo originál. Napiš mi přes formulář, o co přesně máš zájem a já se ti obratem ozvu.
              </p>
            )}
          />
          <BuyForm
            recaptchaKey={'6Le-9nQUAAAAABSeZRmb6L8nnTpimXXod_kLJVDO'}
            variants={data.variants}
            imgTitle={imgTitle}
          />
        </Box>
      </Box>
      <Box width={[1, 1, 1, 2/5, 2/5]} px={[3,3, 3, 0, 0]} >
        {data?.image?.fluid &&
          <Img fluid={data?.image?.fluid} alt={imgTitle} />
        }
        {data.photo &&
          <Image src={data.photo.original.src} alt={data.photo.alt} />
        }

        {data.variants[0]?.name === 'original' && (
          <>
            <h3>
              <Translate text={'What will I get?'} />
            </h3>
            <UL>
              <LI>
                <strong><Translate text={'Size'} /></strong> {data.dimension}cm
              </LI>
              <LI>
                <strong><Translate text={'Material'} />:</strong> {data.material}
              </LI>
              <LI>
                <strong><Translate text={'Year of creation'} />:</strong> {data.year}
              </LI>
              {/*<LI>
                <Translate text={'I put a certificate of authenticity, print/reproduction I will sign for you.'} />
              </LI>*/}
            </UL>
          </>
        )}
      </Box>
    </Flex>
  );
};
